import { createAction } from "@reduxjs/toolkit";
import * as updateVideoActionTypes from "../actionTypes/updateVideoActionTypes";

export const saveVideoInfoTagsAction = createAction<any>(updateVideoActionTypes.SAVE_VIDEO_INFO_TAGS);
